var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-link"},_vm._l((_vm.links),function(ref,index){
var label = ref.label;
var icon = ref.icon;
var url = ref.url;
return _c('a',{key:index,class:("rt-icon-" + icon),attrs:{"href":url,"title":label,"target":"_blank"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }